import { common } from './common';

export const environment = {
  ...common,
  production: false,
};
